import { ReactComponent } from './stepper-plus-s.svg';
export const StepperPlusIconS = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=stepper-plus-s.js.map